// src/App.jsx
import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import supabase from './supabaseClient'
// import your real pages/components:
import TalentDashboard from './pages/TalentDashboard'
import BusinessDashboard from './pages/BusinessDashboard'
import Login from './pages/Login'
// optional: a loading spinner
const Spinner = () => <div style={{padding:24,textAlign:'center'}}>Loading…</div>

// This runs at /creerlio and decides where to send the user
function AppRootRedirect() {
  const navigate = useNavigate()
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    (async () => {
      const { data: { session } } = await supabase.auth.getSession()

      if (!session) {
        navigate('/login', { replace: true })
        setChecking(false)
        return
      }

      // If you store a role on the profile, you can refine this.
      // For now, default to talent dashboard.
      navigate('/dashboard/talent', { replace: true })
      setChecking(false)
    })()
  }, [navigate])

  if (checking) return <Spinner />
  return null
}

export default function App() {
  return (
    <Routes>
      {/* /creerlio -> redirects based on auth */}
      <Route path="/" element={<AppRootRedirect />} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />

      {/* Dashboards */}
      <Route path="/dashboard/talent" element={<TalentDashboard />} />
      <Route path="/dashboard/business" element={<BusinessDashboard />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
